export default __webpack_public_path__ + "static/media/aviary.9dc53fb6.svg";